import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import {
  ChipsContainer,
  freeBetStore,
  FreeBetsWrapper,
  gameConfigStore,
  applicationStore,
  lobbyStore,
} from '@pascal/pascal-core';
import DealerCardsSection from '../../components/DealerCardsSection';
import PlayerCardsSection from '../../components/playerCardsSection';
import { BetActionsPanel } from '../../components/betActionsPanel';
import { WinPopup } from '../../components/winPopUp';
import { DecisionTimer } from '../../components/decisionTimer';
import DecisionButtonsWr from '../../containers/decisionButtonsWr';
import ChipsWrapper from '../../containers/chipsWrapper';
import { doBetStore } from '../../store/doBetStore';
import { CardCentralBox } from '../../components/cardCentralBox';
import { GameCardHolderContainer } from '../../containers/gameCardHolderContainer';
import { CardHolderMobileView } from '../../components/cardHolderView';
import { ShuffleCardsWrapper } from '../../components/shuffleCardWraper';
import { GameTitleSection } from '../../components/gameTitleSection';
import { gameStore } from '../../store/gameStore';
import { cardsStore } from '../../store/cardsStore';
import { RoomType } from '../../enums/roomType';

export const MobileGameMain = observer(() => {
  const { quickBets, selectedChip, setSelectedChip, lastBetModel } = doBetStore;
  const { isBetsClosed } = gameStore;
  const { gameTypes } = lobbyStore;
  const { isGuest } = applicationStore;
  const { gameTypeId } = gameConfigStore;
  const { cardInCentralBox } = cardsStore;
  const { activeFreeBet } = freeBetStore;

  const handleSelectChips = useCallback(
    (chip) => {
      setSelectedChip(chip);
    },
    [setSelectedChip]
  );

  const isShowDecisionTimer = !(isBetsClosed && !lastBetModel?.betModel);
  const isShowDecisionButtons = !(isGuest || (isBetsClosed && !lastBetModel?.betModel));

  const roomColor = useMemo(() => {
    const activeRoom = gameTypes?.find((game) => game.gameTypeId === gameTypeId);

    return activeRoom && activeRoom?.name ? RoomType[activeRoom?.name] : 'blue';
  }, [gameTypes, gameTypeId]);

  return (
    <div>
      <FreeBetsWrapper />
      <div className={`m-game-backside ${roomColor}`}>
        <GameTitleSection />
      </div>
      <div className='m-game-structure'>
        <div className='section-m-game'>
          <div className='m-game-container'>
            <GameCardHolderContainer innerComp={CardHolderMobileView} />
            <ShuffleCardsWrapper />
            <CardCentralBox cardInCentralBox={cardInCentralBox} />
            <DealerCardsSection />
            <PlayerCardsSection />
            <ChipsWrapper />
            <BetActionsPanel />
            <div className='m-central-info-holder'>
              <DecisionButtonsWr isShowDesicion={isShowDecisionButtons} />
            </div>
            <WinPopup />
            {!isBetsClosed ? (
              <ChipsContainer
                selectedChip={selectedChip}
                handleSelectChips={handleSelectChips}
                quickBets={quickBets}
                isFreeChip={!!activeFreeBet.id}
              />
            ) : null}

            <DecisionTimer isShowTimer={isShowDecisionTimer} />
          </div>
        </div>
      </div>
    </div>
  );
});
